function lireLaSuiteEncartPresentation() {
    $('.lire-la-suite').click(function(e) {
        var conteneur = $(this).closest(".encart-presentation");
        conteneur.find('.actif').hide().removeClass('visible-xs');
        conteneur.find('div.description-hidden').removeClass('hidden-xs');
        $(this).remove();
    });
}
window.lireLaSuiteEncartPresentation = lireLaSuiteEncartPresentation;